import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    AppBlockLinkParameter,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Crontab from '@appblocks/codegeneration/SettingsConfigurations/Crontab';

export default class CronEventNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Scheduled Event';
        this.id = 'node_cron_event';
        this.icon = 'IoCalendarOutline';
        this.linkedFeature = 'cron';
        this.requirements = ['tios'];

        this.outputs = [
            {
                name: 'Expired',
                portId: 'cron_expired',
                params: [] as AppBlockLinkParameter[],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'SCHEDULE',
                name: 'Schedule',
                settingType: SettingType.OPTION,
                refId: 'crontab',
                required: true,
                default: '',
                options: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const project: ProjectConfiguration = this.project;
            const SCHEDULE = project.getFeature(this.getSettingValue('SCHEDULE')) as Crontab;
            if (SCHEDULE) {
                const name = SCHEDULE.getSettingValue('NAME');
                return `{{$${name}}} ${SCHEDULE.cronParser(SCHEDULE.getSettingValue('PATTERN'))}`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const SCHEDULE = project.getFeature(this.getSettingValue('SCHEDULE')) as Crontab;
        if (SCHEDULE) {
            const name = SCHEDULE.getSettingValue('NAME');
            return `{{$${name}}} ${SCHEDULE.cronParser(SCHEDULE.getSettingValue('PATTERN'))}`;
        }
        return this.name;
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const SCHEDULE = project.getFeature(this.getSettingValue('SCHEDULE'));
        if (!SCHEDULE) {
            return blocks;
        }

        const NAME = SCHEDULE.getSettingValue('NAME');

        const links = project.getNodeLinks(this, 'cron_expired');
        if (links.length > 0) {
            const link = links[0];

            const template = `${project.getCodeLocationStart()}${link.getSourceId()}${project.getCodeLocationEnd()}`;

            blocks.push({
                location: `cron_expired_${NAME}`,
                id: link.getSourceId(),
                blockType: BlockType.CODE,
                template,
            });
        }

        return blocks;
    }

    getDetails(): string {
        return `
This block is triggered when a **Scheduler** event occurs.`;
    }
}
